// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function() {
    var siteMainDivs = document.querySelectorAll('.site-main > div');
    siteMainDivs.forEach(function(div) {
        div.setAttribute('data-aos', 'fade-up');
    });
    AOS.init();
});